import styles from "./index.module.scss";
import logoName from "@assets/svg/logo-name.svg";
import logoOutline from "@assets/svg/logo-outline.svg";
import chip from "@assets/svg/chip.svg";
import chip2 from "@assets/svg/chip2.svg";
import sol from "@assets/svg/sol.svg";
import sol2 from "@assets/svg/sol2.svg";
import card from "@assets/svg/card.svg";
import card2 from "@assets/svg/card2.svg";
import chip3 from "@assets/svg/chip3.svg";
import { useForm, ValidationError } from "@formspree/react";

export default function ComingSoon(): JSX.Element {
  const [state, handleSubmit] = useForm("mjvlgned");

  return (
    <div className={styles.bg}>
      <img src={logoOutline} className={styles.logoOutline} alt="" />

      <div className={styles.content}>
        <div className={styles.content__wrapper}>
          <img src={chip2} className={styles.chip2} alt="" />
          <img src={sol} className={styles.sol} alt="" />
          <img src={sol2} className={styles.sol2} alt="" />
          <img src={card} className={styles.card} alt="" />
          <img src={card2} className={styles.card2} alt="" />
          <img src={chip3} className={styles.chip3} alt="" />

          {/* <img src={logo} className={styles.logo} alt="" /> */}
          <img src={logoName} className={styles.logoName} alt="" />
          <h1>Coming Soon</h1>
          <div className={styles.subtitle}>
            PVP Gambling Arena powered by Solana blockchain coming soon.
          </div>
          <div className={styles.email}>
            <img src={chip} className={styles.chip} alt="" />

            <form onSubmit={handleSubmit}>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="Please enter your email address"
              />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />
              <button
                type="submit"
                disabled={state.submitting || state.succeeded}
                className={state.succeeded ? styles.check : ""}
              >
                {state.succeeded ? "✓" : "Send"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
